<template>
  <div id="app" :class="{ 'dark-mode': isDarkMode }">
    <button class="dark-mode-toggle" @click="toggleDarkMode" :title="isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'">
      {{ isDarkMode ? '☀️' : '🌙' }}
    </button>
    
    <h1>す早く</h1>

    <div id="nav">
      <router-link to="/">Home</router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isDarkMode: false,
    };
  },
  mounted() {
    // 從 localStorage 讀取 dark mode 設定
    const savedDarkMode = localStorage.getItem('subayaku-dark-mode');
    if (savedDarkMode !== null) {
      this.isDarkMode = savedDarkMode === 'true';
    }
    // 同步 body 的 dark mode class
    this.updateBodyClass();
  },
  watch: {
    isDarkMode() {
      this.updateBodyClass();
    },
  },
  methods: {
    updateBodyClass() {
      if (this.isDarkMode) {
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
      }
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      localStorage.setItem('subayaku-dark-mode', this.isDarkMode.toString());
    },
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  transition: background-color 0.3s, color 0.3s;

  &.dark-mode {
    background-color: #1a1a1a;
    color: #e0e0e0;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  transition: background-color 0.3s, color 0.3s;

  &.dark-mode {
    background-color: #1a1a1a;
    color: #e0e0e0;

    h1 {
      color: #e0e0e0;
    }

    hr {
      border-color: #444;
    }

    #nav a {
      color: #b0b0b0;

      &:hover {
        color: #c792ea;
      }

      &.router-link-exact-active {
        color: #42b983;
      }
    }

    // Home.vue 元件的 dark mode 樣式
    .section-question {
      background-color: #2c5f7f !important;
      color: #e0e0e0;
    }

    .input-answer {
      background-color: #2a2a2a;
      color: #e0e0e0;
      border: 1px solid #444;
    }

    .btn {
      background-color: #1a5f5f;
      color: #e0e0e0;

      &:hover {
        background-color: #2a7f7f;
      }
    }

    .start-btn {
      background-color: #3a3a3a !important;
      color: #888 !important;
      text-shadow: -1px -1px #000, 1px 1px #555 !important;
      box-shadow: 0 .2em #555 !important;
    }

    .completed-list {
      color: #b0b0b0;
    }
  }
}

.dark-mode-toggle {
  position: fixed;
  top: 20px;
  right: 20px;
  font-size: 1.5rem;
  padding: 10px 15px;
  border: none;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s;
  z-index: 1000;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
  }
}

h1{
  margin-bottom: 0px;
}

@media (max-width: 1024px) {
  .subHeading {
    display: block;
  }
  .headingSplit{
    display: none;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;
    font-size: 1.3rem;
    margin-left: 3%;
    margin-right: 3%;
    text-decoration: none;

    &:hover {
      color: rebeccapurple;
    }

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
